import { render } from "./ContactUs.vue?vue&type=template&id=d6ad96a4&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=d6ad96a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d6ad96a4"

export default script